import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

export default function DecisionTimeline({ events }) {
  if (events.length === 0) return null;

  const getStatusBadge = (event) => {
    if (event.type === 'crisis') {
      return (
        <Badge className="bg-red-500/20 text-red-300 border-red-500/50">
          Crisis Start
        </Badge>
      );
    }

    if (event.timing === 'proactive') {
      return (
        <Badge className="bg-emerald-500/20 text-emerald-300 border-emerald-500/50">
          ⚡ Proactive
        </Badge>
      );
    }

    if (event.timing === 'reactive') {
      return (
        <Badge className="bg-blue-500/20 text-blue-300 border-blue-500/50">
          ✓ Reactive
        </Badge>
      );
    }

    return (
      <Badge className="bg-red-500/20 text-red-300 border-red-500/50">
        ❌ Delayed
      </Badge>
    );
  };

  return (
    <div className="mt-8 mb-12">
      <h3 className="text-xl font-semibold text-gray-50 mb-6">Decision Timeline</h3>

      <div className="bg-slate-900 border border-white/10 rounded-xl overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-white/10 hover:bg-slate-800/50">
              <TableHead className="text-gray-400 font-semibold">Time</TableHead>
              <TableHead className="text-gray-400 font-semibold">Event</TableHead>
              <TableHead className="text-gray-400 font-semibold text-right">Delay</TableHead>
              <TableHead className="text-gray-400 font-semibold text-right">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {events.map((event, idx) => (
              <TableRow
                key={idx}
                className="border-white/10 hover:bg-slate-800/50 transition-colors"
              >
                <TableCell className="font-mono text-gray-50 font-medium">
                  {event.time}
                </TableCell>
                <TableCell className="text-gray-50">{event.label}</TableCell>
                <TableCell className="text-gray-400 text-right">
                  {event.delay !== undefined ? `${event.delay} min` : '—'}
                </TableCell>
                <TableCell className="text-right">{getStatusBadge(event)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
